import { z } from "zod";
export const PerformanceSloRegistryV1Schema = z
    .object({
    schemaVersion: z.literal("performance-slo-registry.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalPerformanceSloRegistry(recordedAt) {
    return PerformanceSloRegistryV1Schema.parse({
        schemaVersion: "performance-slo-registry.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=performance-slo-registry.js.map